import { Redirect } from '@containers';

export default [
  {
    path: '/redirect',
    component: Redirect,
    exact: true,
  },
];
